module.exports = __webpack_public_path__ + "static/profilePic-65888fc9069f9144f4dba9247e418bcf.jpg";